
import React, { createContext, useContext, useState } from 'react';

// Create a context for managing API loading state
export const ApiContext = createContext();

// Provider component to wrap your application
export const ApiProvider = ({ children }) => {
  const [isApiLoading, setIsApiLoading] = useState(false);

  // Helper function to wrap API calls with loading indicators
  const callApi = async (apiFunction, ...args) => {
    try {
      setIsApiLoading(true);
      return await apiFunction(...args);
    } finally {
      setIsApiLoading(false);
    }
  };

  return (
    <ApiContext.Provider value={{ isApiLoading, setIsApiLoading, callApi }}>
      {children}
    </ApiContext.Provider>
  );
};

// Custom hook for using the API context
export const useApi = () => useContext(ApiContext);
